import * as React from "react";
const SvgEtherium = (props) => (
  <svg
    width={36}
    height={36}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={18} cy={18} r={18} fill="#000" />
    <path
      d="m24.29 18.187-5.846 3.589-5.85-3.589 5.85-10.085 5.846 10.085Zm-5.846 4.741-5.85-3.588 5.85 8.562 5.85-8.562-5.85 3.588Z"
      fill="#ECECEC"
    />
  </svg>
);
export default SvgEtherium;
